export const types = {
  GET: 'GET_APP_AREAS',
};

export const appAreasReducer = (state = [], action) => {
  switch (action.type) {
    case types.GET:
      return action.payload;
    default:
      return state;
  }
};
